import { getTrendingBarAssetQuery } from './watchlistHelperFunctions';
import { capitalize } from './capitalize';

export function getLocationParentData(topic, path = '#') {
  let { parent } = topic;
  const breadcrumbs = [{
    name: topic.name,
    path,
  }];
  const parents = [];

  while (parent) {
    const [key, value] = Object.entries(parent)[0];

    breadcrumbs.unshift({
      name: value.name,
      path: `${key}/${value.slug}/news`,
    });
    parents.push(
      getTrendingBarAssetQuery(value, capitalize(key)),
    );
    parent = value.parent;
  }

  return {
    breadcrumbs,
    parents,
  };
}
